import React, { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { numeralCustom } from "../../../../../utils/helpers";
import { useAlertContext } from "../../../../../contexts/alert/AlertProvider";
import { asyncDelete } from "../../../../../utils/httpRequests";
import { updateCurrentHd } from "../../../../../redux/reducers/restaurant.reducer";
import PaymentInfo from "./payment/PaymentInfo";
import { useRestaurantContext } from "../../../RestaurantPage";

interface IBottom {
  height: string;
}

function Bottom({ height }: IBottom) {
  const { currentHd, tables } = useSelector((state: any) => state.restaurant);
  const { token } = useSelector((state: any) => state.auth);
  const app = useSelector((state: any) => state.app.data);
  const [openInfo, setOpenInfo] = useState<boolean>(false);
  const { showAlert } = useAlertContext();
  const { updateCurrentTable, saveHd } = useRestaurantContext();
  const dispatch = useDispatch();

  const handleDeleteHd = async () => {
    if (!currentHd) return;
    const resp = await asyncDelete({
      apiCode: "pbl_nh",
      token,
      idApp: app?._id,
      id: currentHd?._id,
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi xóa hóa đơn",
      });
    } else {
      // cập  nhật lại trạng thái bàn
      const currentTable = (tables || []).find(
        (table: any) => table.ma_ban === currentHd?.ma_ban
      );
      await updateCurrentTable(currentTable);
      dispatch(updateCurrentHd(null));
    }
  };

  return (
    <>
      <PaymentInfo open={openInfo} onClose={() => setOpenInfo(false)} />
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          height,
          backgroundColor: "background.paper",
          borderRadius: "10px",
          px: 2,
        }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography sx={{ fontWeight: 600, color: "error.main" }}>
            Tổng tiền
          </Typography>
          <Typography>
            {numeralCustom(currentHd?.t_tt_nt || 0).format()}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <Button
            disabled={!currentHd}
            onClick={() =>
              showAlert({
                type: "warning",
                title: "Xác nhận",
                message: "Bạn có chắc muốn xóa hóa đơn này không ?",
                onConfirm: handleDeleteHd,
              })
            }
            variant="contained"
            color="error"
            sx={{ boxShadow: "none", "&:hover": { boxShadow: "none" } }}
          >
            Xóa
          </Button>
          {/* <Button
            disabled={!currentHd}
            onClick={() => saveHd(3)}
            variant="contained"
            color="secondary"
            sx={{ boxShadow: "none", "&:hover": { boxShadow: "none" } }}
          >
            In tạm tính
          </Button> */}
          <Button
            disabled={!currentHd}
            onClick={() => setOpenInfo(true)}
            variant="contained"
            color="primary"
            sx={{
              boxShadow: "none",
              color: "common.white",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Thanh toán
          </Button>
        </Stack>
      </Stack>
    </>
  );
}

export default Bottom;
